import { gql } from '@apollo/client';

export const ENQUEUE_EVALUATE_APPLICATION_MUTATION = gql`
  mutation EnqueueEvaluateApplication($applicationId: String!) {
    enqueueEvaluateApplication(applicationId: $applicationId)
  }
`;

export default ENQUEUE_EVALUATE_APPLICATION_MUTATION;
